export const FirstRankIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <g clipPath="url(#clip0)">
        <path
          fill="#FF4058"
          d="M5.125 20.574 2.1 26.626a.938.938 0 0 0 .838 1.357H7.49l2.731 3.642a.935.935 0 0 0 1.588-.143l2.852-5.704a13.85 13.85 0 0 1-9.536-5.204M29.884 26.626l-3.026-6.052a13.85 13.85 0 0 1-9.536 5.204l2.852 5.704a.937.937 0 0 0 1.588.143l2.732-3.642h4.552a.938.938 0 0 0 .838-1.357"
        ></path>
        <path
          fill="#FFDC23"
          d="M27.967 11.983C27.967 5.376 22.59 0 15.983 0S4 5.376 4 11.983s5.376 11.984 11.983 11.984 11.984-5.376 11.984-11.984"
        ></path>
        <path
          fill="#fff"
          d="M18.004 17h-2.35v-4.535q0-.826.036-1.512-.217.264-.54.55l-.972.804-1.201-1.477 2.941-2.396h2.086z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h32v32H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );

  export const SecondRankIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path
        fill="#FF4058"
        d="M5.125 20.574 2.1 26.626a.938.938 0 0 0 .838 1.357H7.49l2.731 3.642a.935.935 0 0 0 1.588-.143l2.852-5.704a13.85 13.85 0 0 1-9.536-5.204M29.884 26.626l-3.026-6.052a13.85 13.85 0 0 1-9.536 5.204l2.852 5.704a.937.937 0 0 0 1.588.143l2.732-3.642h4.552a.938.938 0 0 0 .838-1.357"
      ></path>
      <path
        fill="#9E9E9E"
        d="M27.967 11.983C27.967 5.376 22.59 0 15.983 0S4 5.376 4 11.983s5.376 11.984 11.983 11.984 11.984-5.376 11.984-11.984"
      ></path>
      <path
        fill="#fff"
        d="M19.059 17h-6.217v-1.523l2.092-2.116q.896-.937 1.172-1.277.275-.346.38-.592.112-.246.112-.515a.67.67 0 0 0-.217-.528q-.216-.193-.61-.193-.403 0-.82.234a5.8 5.8 0 0 0-.931.68l-1.272-1.488q.663-.592 1.114-.844.45-.258.978-.393.534-.134 1.195-.134.833 0 1.483.293.656.293 1.014.837.363.54.363 1.213a3.2 3.2 0 0 1-.516 1.776q-.264.41-.703.867-.434.457-1.857 1.734v.059h3.24z"
      ></path>
    </svg>
  );

  export const ThirdRankIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <g clipPath="url(#clip0)">
        <path
          fill="#FF4058"
          d="M5.125 20.574 2.1 26.626a.938.938 0 0 0 .838 1.357H7.49l2.731 3.642a.935.935 0 0 0 1.588-.143l2.852-5.704a13.85 13.85 0 0 1-9.536-5.204M29.884 26.626l-3.026-6.052a13.85 13.85 0 0 1-9.536 5.204l2.852 5.704a.937.937 0 0 0 1.588.143l2.732-3.642h4.552a.938.938 0 0 0 .838-1.357"
        ></path>
        <path
          fill="#D09337"
          d="M27.967 11.983C27.967 5.376 22.59 0 15.983 0S4 5.376 4 11.983s5.376 11.984 11.983 11.984 11.984-5.376 11.984-11.984"
        ></path>
        <path
          fill="#fff"
          d="M18.772 10.291q0 .797-.486 1.371-.488.568-1.407.826v.035q2.145.27 2.145 2.028 0 1.196-.95 1.88-.942.686-2.625.686-.69 0-1.283-.1a6.7 6.7 0 0 1-1.271-.363v-1.922q.563.287 1.142.428.586.135 1.079.135.761 0 1.107-.211.352-.217.352-.674 0-.351-.182-.539-.182-.194-.586-.287-.405-.1-1.055-.1h-.527v-1.74h.539q1.764 0 1.764-.902 0-.34-.264-.504-.258-.164-.697-.164-.82 0-1.7.55l-.96-1.546a4.7 4.7 0 0 1 1.388-.668 6 6 0 0 1 1.635-.2q1.33 0 2.086.528.756.527.756 1.453"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h32v32H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );

  export const StarIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      id="Capa_1"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 49.9 49.9"
      {...props}
    >
      <path
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.15"
        d="M48.9 22.7c1-1 1.3-2.4.9-3.7s-1.5-2.2-2.9-2.4l-12.1-1.8c-.5-.1-1-.4-1.2-.9L28.2 3c-.6-1.2-1.8-2-3.2-2s-2.6.8-3.2 2l-5.4 11c-.2.5-.7.8-1.2.9L3.1 16.6C1.7 16.8.6 17.7.2 19s-.1 2.7.9 3.7l8.7 8.5c.4.4.5.9.5 1.4l-2.1 12c-.2 1.4.3 2.7 1.4 3.5s2.6.9 3.8.3l10.8-5.7q.75-.3 1.5 0l10.8 5.7c.5.3 1.1.4 1.7.4.7 0 1.5-.2 2.1-.7 1.1-.8 1.7-2.1 1.4-3.5l-2.1-12c-.1-.5.1-1 .5-1.4zM37.7 33l2.1 12c.1.6-.1 1.2-.6 1.5-.5.4-1.1.4-1.7.1L26.6 41c-.5-.3-1.1-.4-1.7-.4s-1.1.1-1.7.4l-10.8 5.7c-.5.3-1.2.2-1.7-.1q-.75-.6-.6-1.5l2.1-12c.2-1.2-.2-2.3-1-3.2l-8.7-8.5c-.4-.4-.6-1-.4-1.6s.7-1 1.3-1.1l12.1-1.8c1.2-.2 2.2-.9 2.7-2l5.4-11c.2-.5.8-.9 1.4-.9s1.1.3 1.4.9l5.4 11c.5 1.1 1.5 1.8 2.7 2l12.1 1.8c.6.1 1.1.5 1.3 1.1s0 1.2-.4 1.6l-8.7 8.5c-.9.7-1.3 1.9-1.1 3.1z"
        opacity="0.6"
      ></path>
    </svg>
  );
  